import {ajvValidator} from './ajv_validator';


export const validateVdkSchema = json => {
    return true;
};

// export const validateVdkSchema = json => {
//   const validate = ajvValidator.compile(vdkJsonSchema);
//   return validate(json);
// };

const vdkJsonSchema = {
    required: ['blockchainUid', 'documentId'],
    type: 'object',
    properties: {
        blockchainUid: {
            type: 'string',
        },
        documentId: {
            type: 'string',
        },
        address: {
            type: 'object',
            properties: {
                flatNumber: {
                    type: 'string',
                },
                houseNumber: {
                    type: 'string',
                },
                street: {
                    type: 'string',
                },
                streetName: {
                    type: 'string',
                },
            },
        },
        people: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    birthDate: {
                        type: 'string',
                    },
                    birthDay: {
                        type: 'string',
                    },
                    birthPlace: {
                        type: 'string',
                    },
                    checkInDate: {
                        type: 'string',
                    },
                    citizenship: {
                        type: 'string',
                    },
                    document: {
                        type: 'string',
                    },
                    firstName: {
                        type: 'string',
                    },
                    givenName: {
                        type: 'string',
                    },
                    lastName: {
                        type: 'string',
                    },
                    fromAddress: {
                        type: 'string',
                    },
                    martialState: {
                        type: 'string',
                    },
                    outAddress: {
                        type: 'string',
                    },
                    registrationDate: {
                        type: 'string',
                    },
                    registrationType: {
                        type: 'string',
                    },
                },
            },
        },
    },
};
